import React from "react";
import { Cross2Icon } from "@radix-ui/react-icons";

interface GalleryItem {
  id: string;
  s3Url: string;
  name: string;
}

interface BrandKitGalleryProps {
  items: GalleryItem[];
  onItemClick: (item: GalleryItem) => void;
  onRemove: (id: string) => void;
  seeAllLabel: string;
  onSeeAll: () => void;
}

const BrandKitGallery: React.FC<BrandKitGalleryProps> = ({ items, onItemClick, onRemove, seeAllLabel, onSeeAll }) => {
  if (items.length === 0) return null;

  return (
    <div>
      {/* Horizontal scrollable grid: single row when ≤2 items, 2 rows when more */}
      <div
        style={{
          display: "grid",
          gridTemplateRows: items.length > 2 ? "84px 84px" : "84px",
          gridAutoFlow: "column",
          gridAutoColumns: 84,
          gap: 6,
          marginTop: 4,
          overflowX: "auto",
          overflowY: "hidden",
          paddingBottom: 4,
        }}
      >
        {items.map((item) => (
          <div
            key={item.id}
            style={{
              position: "relative",
              width: 84,
              height: 84,
              borderRadius: 4,
              overflow: "hidden",
              backgroundColor: "#F0F0F8",
              flexShrink: 0,
            }}
            className="brand-kit-gallery-item"
          >
            <img
              src={item.s3Url}
              alt={item.name}
              onClick={() => onItemClick(item)}
              title={`Click to add "${item.name}" to canvas`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                cursor: "pointer",
              }}
            />
            <button
              onClick={() => onRemove(item.id)}
              title="Remove"
              className="brand-kit-gallery-remove"
              style={{
                position: "absolute",
                top: 2,
                right: 2,
                width: 16,
                height: 16,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                backgroundColor: "rgba(255,255,255,0.85)",
                border: "none",
                cursor: "pointer",
                opacity: 0,
                transition: "opacity 0.15s",
              }}
            >
              <Cross2Icon style={{ width: 10, height: 10 }} />
            </button>
          </div>
        ))}
      </div>

      {/* See all label - only show when more than 4 items */}
      {items.length > 4 && (
        <div
          onClick={onSeeAll}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 4,
            marginTop: 8,
            cursor: "pointer",
          }}
        >
          <span
            style={{
              color: "#0C172C",
              fontFamily: '"Inter", sans-serif',
              fontSize: 12,
              fontWeight: 400,
              lineHeight: "20px",
            }}
          >
            {seeAllLabel}
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.26994 2.29017C7.102 2.4476 7.102 2.70962 7.26994 2.86668L10.4201 5.81971L1.51842 5.82265C1.2761 5.82302 1.0835 6.00357 1.0835 6.23072C1.0835 6.45788 1.2761 6.6443 1.51842 6.6443L10.4201 6.64137L7.26994 9.58889C7.102 9.75183 7.102 10.0142 7.26994 10.1713C7.44376 10.3342 7.72366 10.3342 7.89121 10.1713L11.7871 6.51916C11.961 6.36173 11.961 6.09971 11.7871 5.94265L7.89121 2.29017C7.72327 2.12723 7.44376 2.12723 7.26994 2.29017Z"
              fill="#222336"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default BrandKitGallery;
